'use client';

import { c as _c } from "react/compiler-runtime";
import { useFormContext, useWatch } from 'react-hook-form';
import { useDecisions } from '@libs/common-next';
import { getAutoshipCadenceByValue } from '@libs/common-types';
import { AutoshipFrequencySelect, getAutoshipFrequencyItems } from '../product-details';
import type { MiniPdpForm } from './types';
export function MiniPdpAutoshipFrequency() {
  const $ = _c(9);
  const as_freq_5_7 = useDecisions("as_freq_5_7");
  const {
    setValue
  } = useFormContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      name: ["autoshipFrequency", "autoshipUnit"]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [autoshipFrequency, autoshipUnit] = useWatch(t0);
  let t1;
  if ($[1] !== setValue) {
    t1 = value => {
      const cadence = getAutoshipCadenceByValue(value);
      if (!cadence) {
        return;
      }
      setValue("autoshipFrequency", cadence.frequency, {
        shouldDirty: true,
        shouldValidate: true
      });
      setValue("autoshipUnit", cadence.unitOfMeasure, {
        shouldDirty: true,
        shouldValidate: true
      });
    };
    $[1] = setValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleChange = t1;
  let t2;
  if ($[3] !== as_freq_5_7) {
    t2 = getAutoshipFrequencyItems({
      withOneTime: false,
      as_freq_5_7
    });
    $[3] = as_freq_5_7;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `${autoshipFrequency}_${autoshipUnit}`;
  let t4;
  if ($[5] !== handleChange || $[6] !== t2 || $[7] !== t3) {
    t4 = <AutoshipFrequencySelect items={t2} value={t3} onChange={handleChange} testId="mini-pdp-autoship-frequency" />;
    $[5] = handleChange;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}